export default function pageBtnClassInit(coreHandlerInstance) {
  const targetClassName = ".js__page-btn";
  const topClassName = "#js__top";
  const headerIdName = ".l-header";
  const coreHandler = coreHandlerInstance;

  class PageBtnClass {
    constructor(ele) {
      this.instanceType = "PageBtnClass";
      this.ele = ele;
      this.data = {
        Page: ele.getAttribute('data-page') || null
      };
      this.selected = false;
      this.clickHandler = this.clickEvent.bind(this);
      this.ele.addEventListener("click", this.clickHandler);
    }

    clickEvent(e) {
      e.preventDefault();
      const topElement = document.querySelector(topClassName);
      const headerHeight = document.querySelector(headerIdName).offsetHeight;
      window.scroll(0, topElement.offsetTop - headerHeight);

      this.removeEvent();
      coreHandler.pageBtnEvent(this.data);
    }

    removeEvent() {
      this.ele.removeEventListener("click", this.clickHandler);
    }

    static init() {
      const instanceList = [...document.querySelectorAll(targetClassName)].map(v => new PageBtnClass(v));
      return instanceList;
    }
  }

  PageBtnClass.init();
  return PageBtnClass;
}
